import { NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB } from '../hooks/useNewbuildingBuzzoolaIntegrationTestWebAvailable';

// TODO: Удалить в CD-243910 после завершения эксперимента.
export const NEWBUILDING_BROKER_SELF_REQUEST_FORM = 'newbuilding_booking_independent_application_desktop';

export const EXPERIMENTS: string[] = [
  NEWBUILDING_BROKER_SELF_REQUEST_FORM,
  /**
   * @todo Удалить переменную
   * @description Данный функционал появился в задаче CD-243378, будет удалён в задаче CD-245113
   */
  NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB,
];
